/* Timber custom: fullscreen product media overlay (July 2026). The
   kit-gallery lightbox language brought to product pages: clicking any
   image or video in the main viewer opens a light-backdrop overlay with the
   canon ‹ › controls that walks EVERY product media — images and videos in
   one sequence, wrapping at the ends, with keyboard (←/→/Esc) support.
   Videos play with sound (unmuted — opening/navigating is a user gesture,
   which satisfies autoplay policies; if a browser still refuses, native
   controls are right there). Media comes from the JSON island
   main-product.liquid renders ([data-tgallery-media]), matched to gallery
   items by the data-media-id suffix, so hidden-variant filtering can never
   desync the indexes. Thumbnail clicks keep Dawn's slide-switch behavior;
   only main-viewer clicks are intercepted (capture phase, so video posters
   don't deferred-load inline). */
(function () {
  var island = document.querySelector('[data-tgallery-media]');
  if (!island) return;
  var media;
  try {
    media = JSON.parse(island.textContent);
  } catch (error) {
    return;
  }
  if (!media || !media.length) return;

  var CHEVRON_LEFT =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEVRON_RIGHT =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CLOSE =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';

  var overlay = null;
  var stage = null;
  var counter = null;
  var current = -1;
  var lastFocus = null;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'tgallery';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product media viewer');
    overlay.innerHTML =
      '<div class="tgallery__backdrop" data-tg-close></div>' +
      '<button type="button" class="tgallery__btn tgallery__close" data-tg-close aria-label="Close media viewer">' +
      CLOSE +
      '</button>' +
      '<button type="button" class="tgallery__btn tgallery__nav tgallery__nav--prev" data-tg-prev aria-label="Previous media">' +
      CHEVRON_LEFT +
      '</button>' +
      '<div class="tgallery__stage"></div>' +
      '<button type="button" class="tgallery__btn tgallery__nav tgallery__nav--next" data-tg-next aria-label="Next media">' +
      CHEVRON_RIGHT +
      '</button>' +
      '<p class="tgallery__count" aria-live="polite"></p>';
    document.body.appendChild(overlay);
    stage = overlay.querySelector('.tgallery__stage');
    counter = overlay.querySelector('.tgallery__count');

    overlay.addEventListener('click', function (event) {
      if (event.target.closest('[data-tg-prev]')) step(-1);
      else if (event.target.closest('[data-tg-next]')) step(1);
      else if (event.target.closest('[data-tg-close]')) close();
    });
  }

  function render(index) {
    current = (index + media.length) % media.length;
    var item = media[current];
    stage.innerHTML = ''; /* also halts any playing video */
    var el;
    if (item.type === 'video' && item.sources && item.sources.length) {
      el = document.createElement('video');
      el.controls = true;
      el.autoplay = true;
      el.playsInline = true;
      el.muted = false;
      if (item.preview) el.poster = item.preview;
      item.sources.forEach(function (source) {
        var src = document.createElement('source');
        src.src = source.url;
        src.type = source.mime;
        el.appendChild(src);
      });
      var playing = el.play && el.play();
      if (playing && playing.catch) playing.catch(function () {});
    } else if (item.type === 'external_video' && item.embed) {
      el = document.createElement('iframe');
      el.className = 'tgallery__iframe';
      el.src = item.embed;
      el.allow = 'autoplay; encrypted-media; fullscreen';
      el.setAttribute('allowfullscreen', '');
      el.title = item.alt || 'Product video';
    } else {
      el = document.createElement('img');
      el.src = item.src || item.preview;
      el.alt = item.alt || '';
    }
    stage.appendChild(el);
    counter.textContent = current + 1 + ' / ' + media.length;
    overlay
      .querySelectorAll('.tgallery__nav')
      .forEach(function (nav) {
        nav.hidden = media.length < 2;
      });
  }

  function step(delta) {
    render(current + delta);
  }

  function open(index) {
    if (!overlay) build();
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    document.documentElement.classList.add('tgallery-lock');
    render(index);
    overlay.querySelector('.tgallery__close').focus();
  }

  function close() {
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('tgallery-lock');
    stage.innerHTML = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('keydown', function (event) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (event.key === 'Escape') close();
    else if (event.key === 'ArrowLeft') step(-1);
    else if (event.key === 'ArrowRight') step(1);
  });

  document.addEventListener(
    'click',
    function (event) {
      var item = event.target.closest('.product__media-list .product__media-item');
      if (!item) return;
      var idAttr = item.getAttribute('data-media-id') || '';
      var mediaId = idAttr.split('-').pop();
      var index = -1;
      media.some(function (entry, i) {
        if (String(entry.id) === mediaId) {
          index = i;
          return true;
        }
        return false;
      });
      if (index < 0) return;
      event.preventDefault();
      event.stopPropagation();
      open(index);
    },
    true
  );
})();
